import { render, staticRenderFns } from "./InputChannelName.vue?vue&type=template&id=9c58b61a&scoped=true&"
import script from "./InputChannelName.vue?vue&type=script&lang=js&"
export * from "./InputChannelName.vue?vue&type=script&lang=js&"
import style0 from "./InputChannelName.vue?vue&type=style&index=0&id=9c58b61a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c58b61a",
  null
  
)

export default component.exports